import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
const TooltipButton = ({ message, icon, ...props }) => {
    return (React.createElement(Tooltip, { title: message, arrow: true },
        React.createElement("span", null,
            React.createElement(IconButton, { ...props }, icon))));
};
export default React.memo(TooltipButton);
